<template>
    <div class="form-group mb-0">
        <textarea v-model.lazy="description" class="form-control" placeholder="Hier bitte eingeben.." rows="5" id="comment" style="width: 100%" :style="styles"></textarea>
    </div>
</template>

<script>
    export default {
        name: "customer-discription",

        data: () => ({
            description: ''
        }),

        props: {
            name: {
                type: String,
                required: true
            },
            height: {
                type: String|Number,
                default: 164
            },
        },

        computed: {
            styles () {
                return {
                 height: this.height + 'px'
                }
            }
        },

        watch: {
            description (value) {
                this.$emit('setText', { name:this.name, value:value })
            }
        }
    }
</script>

<style scoped>

</style>